<script>
  import { mapState } from 'vuex'
  import Button from '@/components/ui/Button'
  import Loader from '@/components/Loader'
  import TheHeader from '@/components/ProtectedBag/partials/TheHeader'
  import TheModal from '@/components/ProtectedBag/partials/TheModal'
  import FloatBar from '@/components/ProtectedBag/partials/FloatBar'
  import GoBackButton from '@/components/ProtectedBag/partials/GoBackButton'
  import ModalArticle from '@/components/ProtectedBag/partials/ModalArticle'

  import { createSession } from '@/utils/createSession.js'

  export default {
    name: 'ProtectedBag',
    components: {
      Button,
      FloatBar,
      TheHeader,
      Loader,
      TheModal,
      GoBackButton,
      ModalArticle
    },
    mounted () {
      sessionStorage.removeItem('ciclic:checkout')

      if (!this.quotedDevice) {
        this.redirectToHome()
      }
    },
    data () {
      return {
        isLoading: false,
        openModal: false,
        generalConditionsLink: 'https://files.ciclic.com.br/general_conditions/assurant-bolsa-e-conta-protegida-dez-2022.pdf',
        modalCoverages: [
          {
            generalTitle: 'O que cobre?',
            icon: 'protected-bag-icon-1',
            title: 'Transações eletrônicas sob coação física',
            description: 'Essa cobertura garante o reembolso relativo às transações realizadas via PIX, TED ou DOC exclusivamente da conta bancária informada no momento da contratação do seguro, ocorridos através de Internet Banking ou aplicativos bancários no celular, mediante coação física, até 24 horas anteriores a comunicação do evento junto à instituição financeira.'
          },
          {
            icon: 'protected-bag-icon-2',
            title: 'Compra ou saque sob coação física',
            description: 'Essa cobertura garante o reembolso das compras ou saques efetuados sob coação do titular da conta bancária coberta até 48 horas anteriores ao bloqueio do cartão.'
          },
          {
            icon: 'protected-bag-icon-3',
            title: 'Perda, roubo ou furto de cartões',
            description: 'Essa cobertura garante o reembolso dos débitos indevidamente efetuados (compras não realizadas e/ou não identificadas) até 48 horas anteriores ao bloqueio do cartão, exclusivamente do cartão vinculado a conta bancária informada no momento da contratação do seguro.'
          },
          {
            icon: 'protected-bag-icon-4',
            title: 'Bolsa Protegida',
            description: 'Essa cobertura garante o pagamento de uma indenização dos itens que forem roubados ou furtados junto com o cartão segurado. Cobertura válida para itens com Nota Fiscal, cujo valor possa ser comprovado. (Bolsa, carteira, óculos de sol ou grau, cosméticos, chaves, etc.',
            iconBottom: 'protected-bag-icon-7',
            labelBottom: 'Necessário apresentar a Nota Fiscal dos itens'
          },
          {
            generalTitle: 'O que não cobre?',
            icon: 'protected-bag-icon-5',
            title: 'Golpes realizados no WhatsApp, como solicitações de transferência e Pix',
            description: 'O seguro não cobre prejuízos decorrentes de transações realizadas por fraude sem coação física, erro ou engano do segurado.'
          },
          {
            icon: 'protected-bag-icon-5',
            title: 'Proteção de um cartão que não esteja vinculado ao seguro contratado',
            description: 'O seguro não cobre as transações realizadas indevidamente em um cartão que não esteja vinculado à conta bancária informada no momento da contratação do seguro.'
          },
          {
            icon: 'protected-bag-icon-5',
            title: 'Roubo ou furto do celular ou qualquer outro aparelho eletrônico (notebook, smartwatch e tablet)',
            description: 'O seguro não cobre aparelhos eletrônicos que forem roubados ou furtados junto com sua bolsa. Para proteger seus aparelhos eletrônicos, você pode realizar a adesão do Seguro Celular e Portáteis e garantir também a segurança dos seus eletrônicos ;)'
          },
          {
            icon: 'protected-bag-icon-6',
            title: 'Importante',
            description: 'A proteção está disponível para as transações realizadas na conta corrente e cartão de débito vinculados à conta corrente informada. Não há cobertura para transações do cartão de crédito.',
            backgroundColor: '#DAF7F5'
          }
        ]
      }
    },
    computed: {
      ...mapState(['appSettings', 'quotedDevice']),
      maxOptionAllowedPriceDevice () {
        const insuranceTypeList = this.quotedDevice.somenteRoubo ? 'theftPaymentOptions' : 'completePaymentOptions'
        return this.currency(this.quotedDevice.device[insuranceTypeList].at(-1))
      },
      maxOptionAllowedPriceBag () {
        return this.currency(this.protectedBag.bagOptions.at(-1))
      },
      protectedBag () {
        return this.quotedDevice.promoBag
      },
      fileIconPath () {
        return require(`@/assets/svg/protected-bag-icon-8.svg`)
      }
    },
    methods: {
      currency (value) {
        return 'R$ ' + Number(value).toFixed(2).replace('.', ',').toString()
      },
      redirectToHome () {
        this.$router.push({ name: 'Home' })
      },
      goToCheckout () {
        createSession(this.quotedDevice, this.$sentry)

        const hasMpeWeek = this.appSettings.partner && this.appSettings.partner.slug === 'mpeweek'
        const checkoutLink = hasMpeWeek
          ? `${process.env.VUE_APP_HOME_URL}checkout/#/dados-da-empresa`
          : `${process.env.VUE_APP_HOME_URL}checkout/#/dados-pessoais`

        setTimeout(() => {
          window.location.assign(checkoutLink)
        }, 1000)
      },
      goToProtectedBagAccount () {
        this.$router.push({ name: 'ProtectedBagAccount' })
      },
      toggleModal () {
        this.openModal = !this.openModal
      }
    }
  }
</script>

<template>
  <div id="protected-bag">
    <Loader v-if="isLoading" />

    <TheHeader />

    <b-container>
      <GoBackButton />

      <section class="content">
        <h2 class="content__title">
          Quer proteger suas transações digitais, pix e itens
          por mais <mark class="content__mark">{{ maxOptionAllowedPriceBag }}</mark> ao mês?
        </h2>
        <div class="content__benefits">
          <div class="benefit">
            <img class="benefit__icon" src="../../assets/svg/laptop-money-banknote.svg" alt="Ícone notebook e dinheiro" />
            <p class="benefit__title">Pix e transferências digitais</p>
          </div>
          <div class="benefit">
            <img class="benefit__icon" src="../../assets/svg/wallet-credit-card.svg" alt="Ícone carteira e cartão de crédito" />
            <p class="benefit__title">Uma conta e um cartão seguros</p>
          </div>
          <div class="benefit">
            <img class="benefit__icon" src="../../assets/svg/glasses.svg" alt="Ícone óculos" />
            <p class="benefit__title">Cobertura de itens da bolsa</p>
          </div>
        </div>
        <div class="details">
          <p class="details__description">
            Cobertura de até R$ 2.000,00 com renovação mensal e
            <strong>sem carência</strong>
          </p>
          <div class="details__buttons">
            <Button
              id="ver-todas-as-coberturas"
              class="details__button"
              theme="purple"
              label="Ver todas as coberturas"
              @click="toggleModal"
            />
            <a
              id="condicoes-gerais"
              class="details__anchor"
              :href="generalConditionsLink"
              target="_blank"
            >
              condições gerais
            </a>
          </div>
        </div>
      </section>
    </b-container>

    <FloatBar
      :mainPrice="maxOptionAllowedPriceDevice"
      :additionalPrice="maxOptionAllowedPriceBag"
    >
      <Button
        id="nao-obrigado"
        slot="firstButton"
        class="float-bar__button float-bar__button--no-padding"
        theme="link"
        label="Não, obrigado"
        @click="goToCheckout"
      />
      <Button
        id="adicionar-protecao"
        slot="secondaryButton"
        class="float-bar__button"
        theme="purple-filled"
        label="Adicionar proteção"
        @click="goToProtectedBagAccount"
      />
    </FloatBar>

    <TheModal v-if="openModal" :open="openModal" :toggleModal="toggleModal">
      <ModalArticle
        generalTitle="Como funciona o Seguro Transações Digitais e Pix?"
      >
        <p>O valor de indenização é global, ou seja: caso você acione o seu seguro, terá <em>cobertura de até R$ 2.000,00</em> para todas as coberturas. O limite é renovado mensalmente.</p>
      </ModalArticle>
      <ModalArticle
        v-for="(coverage, index) in modalCoverages"
        :key="`coverage-${index}`"
        v-bind="coverage"
      />
      <ModalArticle
        backgroundColor="#F5F7FA">
        <div class="general-conditions">
          <p>
            Para mais informações e consulta na íntegra de todos os riscos excluídos, é importante consultar as Condições Gerais do Seguro aqui.
          </p>
          <p>
            <a
              class="general-conditions__anchor"
              :href="generalConditionsLink"
              target="_blank"
            >
              <img :src="fileIconPath" alt="Ícone do botão Ver condições gerais">
              <span>Ver condições gerais</span>
            </a>
          </p>
        </div>
      </ModalArticle>
    </TheModal>
  </div>
</template>

<style lang="scss" scoped>
  #protected-bag {
    min-height: 100vh;
    background: #F5F5F5;
    color: #3F4956;
    position: relative;

    @media (max-width: 767px) {
      padding-bottom: 215px;
    }
  }

  .content {
    margin: 40px 0;
    width: 100%;
    display: grid;
    justify-content: start;
    grid-gap: 40px;
    gap: 40px;

    @media (max-width: 767px) {
      margin: 8px 0;
      grid-gap: 32px;
      gap: 32px;
    }

    &__title {
      font-size: 32px;
      font-weight: 700;
      line-height: 40px;
      max-width: 700px;
      margin-bottom: 0;

      @media (max-width: 767px) {
        font-size: 24px;
        line-height: 28px;
      }
    }

    &__mark {
      color: #6320E9;
      background-color: transparent;
      padding: 0;
    }

    &__benefits {
      display: grid;
      grid-auto-flow: column;
      grid-template-columns: minmax(190px, 1fr);
      justify-content: start;
      grid-gap: 40px;
      gap: 40px;

      @media (max-width: 767px) {
        grid-auto-flow: row;
        grid-gap: 16px;
        gap: 16px;
      }
    }
  }

  .benefit {
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    justify-content: start;
    grid-gap: 16px;
    gap: 16px;

    &__icon {
      background-color: #A585FF4D;
      padding: 14px;
      border-radius: 100%;
      max-width: 52px;
    }

    &__title {
      font-family: 'Rubik', sans-serif;
      font-weight: 500;
      margin: 0;
    }
  }

  .details {
    padding: 16px;
    background-color: #ECEFF4;
    border: 1px dashed #96B4CD;
    border-radius: 8px;
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    grid-gap: 50px;
    gap: 50px;

    @media (max-width: 767px) {
      grid-auto-flow: row;
      grid-gap: 16px;
      gap: 16px;
    }

    &__description {
      margin-bottom: 0;

      @media (max-width: 767px) {
        font-size: 20px;
        line-height: 24px;
        font-weight: bold;
      }
    }

    &__buttons {
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      grid-gap: 16px;
      gap: 16px;

      @media (max-width: 767px) {
        grid-auto-flow: row;
        grid-gap: 0;
        gap: 0;
      }
    }

    &__button {
      @media (max-width: 767px) {
        width: 100%;
      }
    }

    &__anchor {
      color: #6320E9;
      font-weight: bold;
      text-align: center;
      padding: 10px 0;
    }
  }

  .general-conditions {
    p {
      font-size: 14px;
    }

    &__anchor {
      border: 1px solid #D5D5D7;
      border-radius: 28px;
      padding: 12px 24px;
      font-size: 16px;
      color: #373739;
      display: inline-flex;
      gap: 8px;
    }
  }
</style>
